import Vue from 'vue'
import store from '..'
import axios from 'axios'
import API from '@/common/api'

export default {
  namespaced: true,
  state: {
    active: false,
    activeItem: '',
    mainOnly: true,
    list: [],
    position: 'right',
    style: {
      size: 60,
      axisY: false,
      positionBottom: 15,
      positionLeftRight: 15
    }
  },
  mutations: {
    init (state) {
      state.active = false
      state.mainOnly = true
      state.list = []
      state.position = 'right'
      state.style = {
        size: 60,
        axisY: false,
        positionBottom: 15,
        positionLeftRight: 15
      }
    },
    activeFloating (state, data) {
      state.active = data
    },
    floatingMainOnly (state, data) {
      state.mainOnly = data
    },
    floatingStyle (state, data) {
      state.style = Object.assign(state.style, data)
    },
    setActiveItem (state, id) {
      state.activeItem = id || ''
    },
    UPDATE_ITEM (state, payload) {
      const { id, data } = payload || {}
      if (!id || !data) return

      const idx = state.list.findIndex((x) => x && x.id === id)
      if (idx === -1) return

      const next = Object.assign({}, state.list[idx], data)
      Vue.set(state.list, idx, next)
    },
    updateItemFloatingPage(state, payload) {
      const item = state.list.find(x => x.id === payload.id)
      if (!item) return
      Vue.set(item, 'floatingPageData', payload.floatingPageData || null)
    }
  },
  actions: {
    addList ({ state }, data) {
      state.list.push(data)
    },
    updateList ({ state }, data) {
      state.list = data
    },
    updateItem ({ state, commit }, data) {
      commit('UPDATE_ITEM', data)
    },
    removeItem ({ state }, id) {
      state.list = state.list.filter(x => x.id !== id)
    },
    setData ({ state }, data) {
      state.active = typeof (data.active) !== 'undefined' ? data.active : false
      state.mainOnly = typeof (data.mainOnly) !== 'undefined' ? data.mainOnly : true
      state.list = typeof (data.list) !== 'undefined' ? data.list : []
      state.position = typeof (data.position) !== 'undefined' ? data.position : 'right'
      state.style = typeof (data.style) !== 'undefined' ? { ...state.style, ...data.style } : { size: 60, positionBottom: 15, positionLeftRight: 15 }
      return true
    },
    async getFloating () {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          ...API.GET_GVF_PARAMS,
          id: store.state.authentication.requestId,
          file: 'floating/floating.json'
        })
        return res.data.message
      } catch (ex) {
        // alert(ex)
        console.log(ex)
        return false
      }
    },
    async setFloating ({ state }, data) {
      try {
        return axios.post(`${API.BASE_URL}/castit/file`, {
          ...API.SET_GVF_PARAMS,
          id: store.state.authentication.requestId,
          file: 'floating/floating.json',
          data: JSON.stringify(data)
        })
      } catch (ex) {
        alert(ex)
        console.log(ex)
        return false
      }
    },
    setFloatingData ({ dispatch }) {
      return dispatch('getFloating').then(res => {
        if (res) {
          dispatch('setData', res)
        } else {
          const initData = {
            active: false,
            mainOnly: true,
            list: [],
            position: 'right',
            style: {
              size: 60,
              positionBottom: 15,
              positionLeftRight: 15
            }
          }
          dispatch('setData', initData)
        }
        return res
      }).catch((ex) => {
        // console.error('error:', ex)
        // alert(ex)
        console.log(ex)
        return false
      })
    }
  },
  getters: {
    active: state => state.active,
    mainOnly: state => state.mainOnly,
    list: state => {
      return state.list
    },
    style: state => state.style,
    getFloatingPageData: state => {
      const activeItem = state.list.find(item => item.id === state.activeItem)
      return activeItem?.floatingPageData
    }
  }
}
